import { constructionSafety, logisticsAsset, manufacturingAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';
import digitaltwin from '@src/assets/images/digitaltwin/video/traffic-short.mp4';
import img from '@src/assets/images/blog/main/sub/m_p.avif';

export default {
  desc: 'Bạn có bao giờ tưởng tượng rằng mình có thể nhìn thấy nhà hàng, công ty, trường học, thư viện hay chiếc xe buýt quen thuộc trên màn hình kỹ thuật số, giống hệt như ngoài đời thực không? Hơn nữa, không chỉ là hình ảnh tĩnh như ảnh chụp, mà là hình ảnh sống động, phản ánh đúng những gì đang diễn ra theo thời gian thực.',
  keywords: 'Digital twin, chuyển đổi số, thành phố thông minh, RTLS, digital twin, chuyen doi so, thanh pho thong minh, RTLS.',
  ogSite: 'Digital Twin là gì? | Định nghĩa, và các trường hợp ứng dụng',
  title: 'Digital Twin là gì? | Định nghĩa, và các trường hợp ứng dụng',
  ogUrl: 'https://orbro.io/vi/blog/digital-twin',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDn5W_M0e1npdG9n9MzOVOPXstcQFN609JOUoXoNFXx5-5yloUkGMm1ufjGdF0R9JPeeoW9ykX72SA54O2wG8Vc8sW09dZk2e0IDK9TeXeQEa--HWeYTcyW4jGYAJNHeFvfBs5a4BRrjqNwwxwwrqLUiPrfxt1Kh2LXvniTuSqgVgIjcSz_RxNn3xVuLJqTOqR4rqFbVHkYHahb2a4j49UHtTzHmHnfVmpdEQYWJVViBOrZ3tPK0EWAkyAmPCBugIKyPXfG0iiMHGMupqT-0FPP0g20RLM4zBag-s05hL1Ujp7TBBUm4Ib_MBExPF2QSW0-Ko50dZ7a9hFGGpBrZalaWJMlebmqnC01xrRhTTAcFFNKYYDtFKQNXpb6IQ43Ef9F4-Y4sfGroiz6XZChSKlwLGbp72vSY1vYD7KX3GNlBNvYgCchgmuUmC9myCzEJbjRkKRcKOFGCNqOwXq8Ql04pFpN3XNTkmcedlgJ8xLQIH6FvQ0eIrHRjI7BxmwNtFj2PCeXKhfii-bTYi3ZB9ao0wlQkWQ10gL_ZXLOaWbKY8h_pWysjm2m7iZ2zdJyJac7ZlaVuSwFAHC__vc17P51pGrnB957kwOqxbJPEUrfDsAwD0ucwfa9X5wm2OECrV5cGVJVGBUAz55SEPInk4aouVwJ5eGNvbUoi5mFQOqeqQd-SdcSyc9hMrhBbIK8zigjExJpaRWEchpc5nL5PiJ1Ap2b73ReZfichg5q3S7QYZbk1pQVzRkvF5aDagxH3bEDhyA-eoQBmUwXNZ-O1Rlw2yLhARV_3xTok0wVPRN1PRECRlPCwgkFBEOBCTJCHxr4evnVKMdan_h85axDlA4QL5fLDuhScyp8Yiy3f_L-av_QBdqjVIkovYRjt3Ofnds2NKJbIIEDkgjJ5fnvUgNxJHKpuO3_rrqHmZagGcPtWEq1ZiUTSnmPMFUvd0ip-6GeWiZCwnkJNzazZZ3y_sejVcyeAGQpURR2dl9a3CytaKdgrP0E5kIRrKZqFFzMRvEFEsCPQI1yC6GDAlnMfvv72q5nLzjm-gU_soTcmaBcciDyAbOhEPnFgayRxu0QEDHw-A-SJn8Ub_cYlh-adqEbax34AGDlnxQLW5cgoFo0SsnMA2xD14GMSns8hj8HFgyTd1D9LpDViC5e5qZimjm3K6z56isQsFByGjVb6CYaqdICSjtdtWBEsBFjqqxf3SwLXUKU-sdMuNMmi2rJeO5KsRUv2MjSRY6MIWgv0_nv629SFKM93QxSWT3de2SAWHmDtCI0l6zGKm3ts0heoIfsioTAKjyRw0DabC833amSZ4gIWF5IIwIdc9w1mj7lsTSi5JrZKoyo5ul2TTchUf_9QqFj3u7AYcfhreY7UvlPyJD7gzlp0GY8wyKXBvaFFq9_r84ZA8vOdTNArreD3OAi8owfQOAJ2_j4H3e6nsxTjTpWDLIoz0VPfiiT-1YXwlQ3yD0DMRkGckEnpWrCRwF-JTiI-1Cn2OTi1VgH2L1-Mw0wSen_gD_tT9lcRT4vlYC0eyRhDZlfNZAI2E8RRVwxB50SEeBgj=w1906-h1213',
  ogType: 'website',
  date: '2023-12-28',
  tag1: '#DigitalTwin',
  tag2: '#Chuyendoiso',
  tag3: '#Thanhphothongminh',
  tag4: '#Rtls',
  text: [
    {
      head: 'Digital Twin là gì?',
      subHead: '',
      desc: 'Bạn có bao giờ tưởng tượng rằng mình có thể nhìn thấy nhà hàng, công ty, trường học, thư viện hay chiếc xe buýt quen thuộc trên màn hình kỹ thuật số, giống hệt như ngoài đời thực không? Hơn nữa, không chỉ là hình ảnh tĩnh như ảnh chụp, mà là hình ảnh sống động, phản ánh đúng những gì đang diễn ra theo thời gian thực.\nNếu bạn là chủ một nhà hàng, trên đường về nhà mà không nhớ đã tắt gas ở quán hay chưa, bạn không cần phải quay lại kiểm tra. Hay khi đứng ở trạm xe buýt, bạn cũng không cần đoán xem xe buýt sẽ đến khi nào, vì bạn có thể xem vị trí hiện tại của nó ngay lập tức!\nDigital Twin (Song sinh Kỹ thuật số) chính là công nghệ cho phép tái hiện thế giới thực – con người, phương tiện, tòa nhà, hay cả thành phố – trong không gian ảo trên màn hình kỹ thuật số.',
      dot: '',
    },
    {
      head: 'Định nghĩa Digital Twin',
      subHead: '',
      desc: 'Digital Twin là quá trình mô phỏng các đối tượng hoặc quy trình vật lý trong thế giới thực dưới dạng kỹ thuật số, nhằm thu thập và phân tích dữ liệu theo thời gian thực. Nói cách khác, công nghệ này cung cấp một phương pháp hiệu quả để mô phỏng và tối ưu hóa dữ liệu thực tế trong môi trường số. Digital Twin được ứng dụng trong nhiều lĩnh vực như công nghiệp, xây dựng, y tế, ô tô, và nhiều ngành khác.',
      dot: '',
    },
    {
      head: 'Digital Twin hoạt động như thế nào?',
      subHead: '',
      desc: 'Digital Twin là công nghệ chuyển đổi con người, đồ vật, hoặc tòa nhà trong thế giới thực thành dạng kỹ thuật số. Mục tiêu là thu thập dữ liệu về vị trí, trạng thái, hiệu suất của các đối tượng này theo thời gian thực và giám sát chúng trên màn hình số.\nCông nghệ Digital Twin hoạt động dựa trên các giai đoạn chính sau',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thu thập và kết nối dữ liệu',
      desc: 'Trọng tâm của Digital Twin là thu thập và kết nối dữ liệu từ thế giới thực. Các cảm biến, thiết bị IoT và các công cụ khác được sử dụng để thu thập dữ liệu từ nhiều môi trường khác nhau theo thời gian thực. Dữ liệu này sau đó được truyền đến các nền tảng dựa trên đám mây, nơi nó được xử lý và lưu trữ. Nhờ vậy, các tình huống trong thế giới thực được phản ánh chính xác trong môi trường số.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Mô phỏng và mô hình hóa',
      desc: 'Dựa trên dữ liệu thu thập được, Digital Twin tạo ra các mô hình kỹ thuật số chi tiết của các đối tượng vật lý. Các mô hình này xem xét các biến số và yếu tố môi trường để dự đoán và mô phỏng hành vi của đối tượng trong thế giới thực. Qua đó, Digital Twin có thể thử nghiệm các kịch bản khác nhau và tìm ra giải pháp tối ưu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phản ánh và điều khiển theo thời gian thực',
      desc: 'Digital Twin liên kết với thế giới thực theo thời gian thực, cho phép phản ứng ngay lập tức với các thay đổi. Bất kỳ sự kiện hay thay đổi nào trong thế giới thực đều được tự động cập nhật trong Digital Twin. Khi cần thiết, Digital Twin có thể gửi tín hiệu điều khiển đến hệ thống thực tế. Giai đoạn này đảm bảo Digital Twin luôn đồng bộ với thực tế, phản ánh thông tin mới nhất và tác động trực tiếp đến hệ thống vật lý.\nThông qua các giai đoạn này, Digital Twin phản ánh các đối tượng vật lý trong không gian số, hỗ trợ tối ưu hóa thời gian thực và cải thiện quá trình ra quyết định.',
      dot: '',
    },
    {
      head: 'Mối quan hệ với Thành phố Thông minh (Smart City)',
      subHead: '',
      desc: 'Digital Twin đóng vai trò cốt lõi trong việc xây dựng các thành phố thông minh. Bằng cách mô phỏng chính xác các yếu tố vật lý của thành phố và biểu diễn chúng dưới dạng kỹ thuật số, các thành phố thông minh có thể nắm bắt và tối ưu hóa trạng thái của đô thị theo thời gian thực. Ví dụ, Digital Twin của hệ thống giao thông có thể dự đoán và điều chỉnh luồng giao thông, từ đó cải thiện hệ thống giao thông đô thị. Ngoài ra, Digital Twin hỗ trợ giám sát môi trường, giúp quản lý hiệu quả chất lượng không khí, sử dụng nước, và tiêu thụ năng lượng.\nDigital Twin và thành phố thông minh bổ trợ lẫn nhau, cùng phát triển. Các hệ thống của thành phố thông minh được kết nối với Digital Twin để chia sẻ thông tin thời gian thực và thực hiện các hành động phù hợp. Sự tương tác này nâng cao an toàn, hiệu quả và tiện nghi cho cuộc sống đô thị.',
      dot: '',
    },
    {
      head: 'Lợi ích của Digital Twin',
      subHead: 'Có thể ra quyết định thời gian thực',
      desc: 'Digital Twin thu thập và phân tích dữ liệu từ thế giới thực theo thời gian thực, cung cấp thông tin cần thiết để ra quyết định nhanh chóng. Điều này giúp các doanh nghiệp phản ứng kịp thời, đưa ra quyết định dựa trên thông tin mới nhất, từ đó duy trì và nâng cao lợi thế cạnh tranh.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự động hóa và hiệu quả',
      desc: 'Digital Twin tích hợp với các hệ thống tự động hóa, tối ưu hóa quy trình làm việc và nâng cao năng suất. Quyết định tự động dựa trên dữ liệu thực tế giúp đơn giản hóa công việc hàng ngày, giảm thiểu sai sót do con người và cải thiện hiệu quả hoạt động của tổ chức.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giảm chi phí và bảo trì dự đoán',
      desc: 'Sử dụng Digital Twin, các doanh nghiệp có thể giám sát và dự đoán trạng thái của hệ thống vật lý theo thời gian thực. Điều này cho phép thực hiện bảo trì dự phòng, phát hiện sớm các vấn đề tiềm ẩn để giảm chi phí sửa chữa. Đồng thời, dự đoán chính xác dựa trên dữ liệu giúp lập kế hoạch bảo trì hiệu quả, tăng tính ổn định và tiết kiệm chi phí.',
      dot: '',
    },
    {
      head: 'Ứng dụng Digital Twin trong các ngành công nghiệp',
      subHead: 'Ngành sản xuất',
      desc: 'Trong sản xuất, Digital Twin giúp tăng hiệu quả dây chuyền sản xuất. Dựa trên dữ liệu từ từng giai đoạn của quá trình, Digital Twin được xây dựng để giám sát và tối ưu hóa môi trường sản xuất theo thời gian thực. Nhờ đó, các vấn đề trong dây chuyền được phát hiện và khắc phục nhanh chóng, thời gian ngừng sản xuất được giảm thiểu nhờ bảo trì dự đoán. Ngoài ra, Digital Twin còn hỗ trợ giám sát hiệu suất sản phẩm trong suốt vòng đời, từ đó nâng cao chất lượng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ngành năng lượng',
      desc: 'Trong ngành năng lượng, Digital Twin của nhà máy điện hoặc cơ sở hạ tầng năng lượng giúp tối ưu hóa sản xuất và tiêu thụ năng lượng. Việc giám sát trạng thái thiết bị theo thời gian thực cho phép dự đoán và lập kế hoạch bảo trì, sửa chữa. Điều này nâng cao độ ổn định và hiệu quả sản xuất năng lượng, đồng thời giảm chi phí thông qua bảo trì dự đoán.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ngành y tế',
      desc: 'Trong y tế, Digital Twin mô phỏng trạng thái sức khỏe của bệnh nhân, hỗ trợ bác sĩ cung cấp các phương pháp điều trị cá nhân hóa. Ngoài ra, việc giám sát hiệu suất của thiết bị y tế và hệ thống theo thời gian thực đảm bảo vận hành hiệu quả và phản ứng nhanh chóng, nâng cao an toàn và tiện nghi cho bệnh nhân.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ngành ô tô',
      desc: 'Trong ngành ô tô, Digital Twin của xe hơi giúp tối ưu hóa hiệu suất lái và dự đoán nhu cầu bảo trì, sửa chữa. Đặc biệt, với sự phát triển của công nghệ xe tự hành, Digital Twin cải thiện khả năng giám sát môi trường và tương tác của xe, nâng cao an toàn và tiện nghi cho người lái, đồng thời duy trì hiệu suất tối ưu trong suốt vòng đời của xe.',
      dot: '',
    },
    {
      head: 'Triển vọng của Digital Twin',
      subHead: '',
      desc: 'Công nghệ Digital Twin đang được ứng dụng nhanh chóng trong các ngành công nghiệp và được dự đoán sẽ dẫn dắt những đổi mới ở cấp độ cao hơn trong tương lai. Một số triển vọng chính bao gồm:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Vai trò dẫn đầu trong đổi mới công nghiệp',
      desc: 'Digital Twin được kỳ vọng sẽ là trung tâm của sự đổi mới trong các ngành như sản xuất, xây dựng, năng lượng và y tế. Đặc biệt, khi kết hợp với trí tuệ nhân tạo, công nghệ 5G và phân tích dữ liệu lớn, Digital Twin sẽ được sử dụng hiệu quả hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Yếu tố cốt lõi của thành phố thông minh',
      desc: 'Digital Twin sẽ trở thành công nghệ then chốt trong phát triển thành phố thông minh, hỗ trợ quản lý hiệu quả cơ sở hạ tầng đô thị, tối ưu hóa giao thông và giám sát môi trường.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Kết hợp với Internet vạn vật (IoT)',
      desc: 'Khi kết hợp với IoT, Digital Twin sẽ phát huy sức mạnh vượt trội. Khả năng thu thập và phân tích dữ liệu thời gian thực được cải thiện sẽ giúp mô hình hóa các đối tượng vật lý chính xác hơn.',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'Digital Twin phá vỡ ranh giới giữa thế giới vật lý và môi trường số, mang đến các giải pháp đổi mới. Công nghệ này đang thúc đẩy hiệu quả và đổi mới trong nhiều ngành công nghiệp, và trong tương lai, nó được kỳ vọng sẽ mở rộng ứng dụng ở nhiều lĩnh vực hơn nữa.\nNếu bạn muốn tìm hiểu thêm về công nghệ Digital Twin của Obro, vui lòng nhấp vào liên kết dưới đây.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
